import { render, staticRenderFns } from "./AppPOS.vue?vue&type=template&id=2c27f22c&"
import script from "./AppPOS.vue?vue&type=script&lang=js&"
export * from "./AppPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports